module.exports = __webpack_public_path__ + "static/mr-press-13-b226676617d2c33fd94c8e7e253aaa9c.jpg";